import styled from 'styled-components';

import { usePDPDispatch } from 'productTemplate/hooks/usePDPState';
import { PDPStateActions } from 'productTemplate/state/pdpStateReducer';
import { StandardVariantGridItem } from 'productTemplate/components/buyBar/StandardVariantGridItem';
import { Loader } from 'shared/components/Loader';
import { IProductSearch } from 'shared/types/ProductSearch';
import { hideScrollbars } from 'styles/utils/hideScrollbars';
import { variableFontRegular } from 'styles/theme';

export interface IWindowItemVariantGridProps {
  data: IProductSearch[];
  isLoading: boolean;
  description?: string;
}

export const WindowItemVariantGrid = ({
  data,
  isLoading,
  description,
}: IWindowItemVariantGridProps) => {
  const dispatch = usePDPDispatch();

  const handleVariantClick = (variant) => {
    dispatch({ type: PDPStateActions.addWindow, payload: variant });
  };

  if (isLoading) return <Loader style={{ width: '264px' }} />;

  return (
    <WindowItemVariantGrid.Wrapper>
      {description && <WindowItemVariantGrid.Title>{description}</WindowItemVariantGrid.Title>}
      <WindowItemVariantGrid.Grid>
        {data.map((variant) => (
          <StandardVariantGridItem
            key={variant.id}
            productSearch={variant}
            onClick={handleVariantClick}
          />
        ))}
      </WindowItemVariantGrid.Grid>
    </WindowItemVariantGrid.Wrapper>
  );
};

WindowItemVariantGrid.Wrapper = styled.div``;

WindowItemVariantGrid.Grid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 8px;
  row-gap: 16px;
  max-height: 329px;
  min-width: 264px;
  overflow-y: scroll;
  width: 100%;
  max-width: 332px;

  ${hideScrollbars}
`;

WindowItemVariantGrid.Title = styled.div`
  ${variableFontRegular({ size: '9.5px', height: '11px' })};
  text-transform: none;
  margin-bottom: 16px;
`;
